import { parseJwtToken } from './jwt_token';
import { invariant } from '@streem/toolbox';
import { StreemAPI } from '@streem/api';
import { logger } from './logger';
export function isSDKUserToken(token) {
    const data = parseJwtToken(token);
    // embedded sso tokens have streem:api in the issuer field
    return !!data.iss && data.iss.indexOf('streem:api:') === 0;
}
export async function getSDKUserFromCredentials(credentials, companyCode) {
    try {
        const { authIdentity } = await StreemAPI.auth.getCurrentAuthIdentity();
        invariant(authIdentity?.user, 'Expected current AuthIdentity to be a User');
        // For now we assume that if the user does not have a Group Reservation then they must be an ExpertUser. That is
        // not a great assumption to make in general. But at the moment our web code does not implement any flows that
        // would allow a non-expert user to login with an SDK Token that does not include a Group Reservation.
        if (authIdentity.user.groupReservation) {
            return {
                id: credentials.streem_user_id,
                companyId: credentials.streem_company_id,
                exp: credentials.expires_in,
                groupReservation: authIdentity.user.groupReservation,
            };
        }
        else {
            const user = authIdentity.user.user;
            invariant(user, "Received successful GetCurrentAuthIdentity without a 'user.user'");
            return {
                id: credentials.streem_user_id,
                scope: credentials.scope,
                companyCode,
                email: user.email,
                name: user.name,
                avatarUrl: user.avatarUrl,
            };
        }
    }
    catch (error) {
        logger.error({
            msg: 'Error getting current user',
            userId: credentials.streem_user_id,
            error: error,
        });
        throw error;
    }
}
//# sourceMappingURL=sdk_user.js.map